<template>
    <div v-if="metrics.length" :class="$attrs.class">
        <template v-for="metric of metrics">
            <button  
                :key="'button-' + metric.title" 
                :class="{ active: filtered === metric.filter }"
                :disabled="!metricIsClickable(metric)" 
                @click="$emit('filter', metric.filter)">
                {{ metric.title }}
            </button>
        </template>
    </div>
</template>
  
<script>

export default {
    name: "MetricButtons",
    inject: ['sessionsMetricsReport'],
    props: {
    timeframe: {
      type: String,
      required: false,
      default: 'recent'
    },
    filtered: {
      type: String,
      required: false,
      default: 'all'
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
    data() {
        return {
            listShowing: 'all',
        }
    },

    methods: {
        metricIsClickable(metric) {
            return !!metric.filter && metric.metric > 0;
        },

        calcRequested(data) {
            if (!data || !data.requests) return 0;

            return data.requests.pending;
        },
        calcApproved(data) {
            if (!data || !data.requests) return 0;

            return data.requests.approved + data.requests.inProgress;
        },
        calcAll(data) {
            if (!data) return 0;

            let count = 0;
            for (const val of Object.values(data.attended || {})) count += val;
            for (const val of Object.values(data.canceled || {})) count += val;

            return count;
        },
        calcSuccessful(data) {
            if (!data || !data.attended) return 0;

            return data.attended.both;
        },
        calcCanceled(data) {
            if (!data || !data.canceled) return 0;

            return (
                data.canceled.byStudent +
                data.canceled.byStudentWithin24Hours +
                data.canceled.byCounselor +
                data.canceled.byCounselorWithin24Hours +
                data.canceled.byAdmin
            );
        },
        calcNotAttended(data) {
            if (!data || !data.attended) return 0;

            return (
                data.attended.onlyStudent +
                data.attended.onlyCounselor +
                data.attended.neither
            );
        }
    },
    computed: {
        metrics() {
            const data = this.sessionsMetricsReport.data;
            if (this.timeframe === 'upcoming') {
                return [];
            }
            return [
                { title: 'All', filter: 'all', metric: this.calcAll(data) },
                {
                    title: 'Successful',
                    filter: 'successful',
                    metric: this.calcSuccessful(data)
                },
                {
                    title: 'Canceled',
                    filter: 'canceled',
                    metric: this.calcCanceled(data)
                },
                {
                    title: 'Not Attended',
                    filter: 'not attended',
                    metric: this.calcNotAttended(data)
                }
            ];
        },

        divRole() {
            if (this.metrics.some((x) => !!x.filter && x.metric > 0)) {
                return 'radiogroup';
            }
            return '';
        }
    }
}
</script>
  
<style lang="scss" scoped>
.dates {
    color-scheme: light;
    display: flex;
    justify-content: center;
    flex-wrap: nowrap;
    align-items: center;
    background: #fff;
    border-radius: 8px;
    border-right: 1px solid #d1d1d1;
    padding: 0;
    margin: 0;
    height: 46px;
    transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
    text-align: center;

    @media screen and (min-width: $md-min) {
        height: 46px;
        flex-wrap: nowrap;
    }

    label {
        margin: 0;
    }

    input {
        border: 0;
        background: transparent;
        line-height: 2;
        font-size: 14px;
        font-weight: 500;
        text-transform: uppercase;
        max-width: 145px;
        height: 46px;
        padding: 0 16px;
    }

    svg {
        opacity: 0.8;
    }


}
</style>